import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { AuthService } from './shared/services/auth.service';
import { BreadcrumbService } from './shared/services/breadcrumb.service';
import { CaptchaService } from './shared/services/captcha.service';
import { ModalService } from './shared/services/modal.service';
import { ViewportService } from './shared/services/viewport.service';
import { APP_ROUTES } from './shared/constants/app-routes.constant';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('openSessionExpiredModal') openSessionExpiredModal: ElementRef;
  @ViewChild('openSessionIncompleteModal') openSessionIncompleteModal: ElementRef;
  private layoutExcludedRoutes: string[] = [APP_ROUTES.styleguide.url];
  private breadcrumbExcludedRoutes: string[] = [
    APP_ROUTES.home.url,
    APP_ROUTES.myAccount.url,
    APP_ROUTES.satisfactionSurvey.url
  ];
  private modalIsOpenSubscription: Subscription;
  private routerEventsSubscription: Subscription;
  private isLoadingApiAuthSubscription: Subscription;
  private hasApiAuthErrorSubscription: Subscription;
  private isLoadingUserAuthSubscription: Subscription;
  private hasUserAuthErrorSubscription: Subscription;
  private sessionExpiredSubscription: Subscription;
  private sessionIncompleteSubscription: Subscription;
  private isLoadingApiAuth = true;
  private isLoadingUserAuth = true;
  private isDesktopSubscription: Subscription;
  public modalIsOpen: boolean;
  public hasApiAuthError: boolean;
  public hasUserAuthError: boolean;
  public allowSessionExpiredModal: boolean;
  public allowSessionIncompleteModal: boolean;
  public isDesktop: boolean;


  public messageError: string;





  private sessionForbiddenSubscription: Subscription;
  public allowSessionForbiddenModal: boolean;
  @ViewChild('openSessionForbiddenModal') openSessionForbiddenModal: ElementRef;

  get isLoadingAuth() {
    return this.isLoadingApiAuth || this.isLoadingUserAuth;
  }

  get shouldDisplayLayout() {
    const route = this.router.url.split('?')[0];

    if (this.layoutExcludedRoutes.includes(route)) {
      return false;
    }

    return true;
  }

  get shouldDisplayBreadcrumb() {
    const route = this.router.url.split('?')[0];

    if (!this.shouldDisplayLayout || this.breadcrumbExcludedRoutes.includes(route)) {
      return false;
    }

    return true;
  }

  constructor(
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    public captchaService: CaptchaService,
    private changeDetectorRef: ChangeDetectorRef,
    private modalService: ModalService,
    private router: Router,
    private viewportService: ViewportService
  ) {}

  ngOnInit() {
    this.isDesktopSubscription = this.viewportService.isDesktopObservable.subscribe((value) => {
      this.isDesktop = value;
    });

    this.modalIsOpenSubscription = this.modalService.isOpenObservable.subscribe((value) => {
      this.modalIsOpen = value;

      this.changeDetectorRef.detectChanges();
    });

    this.routerEventsSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbService.updateBreadcrumbs();
      });

    this.isLoadingApiAuthSubscription = this.authService.isLoadingApiAuthObservable.subscribe((value) => {
      this.isLoadingApiAuth = value;
    });

    this.hasApiAuthErrorSubscription = this.authService.hasApiAuthErrorObservable.subscribe((value) => {
      this.hasApiAuthError = value;
    });

    this.isLoadingUserAuthSubscription = this.authService.isLoadingUserAuthObservable.subscribe((value) => {
      this.isLoadingUserAuth = value;
    });

    this.hasUserAuthErrorSubscription = this.authService.hasUserAuthErrorObservable.subscribe((value) => {
      this.hasUserAuthError = value;
    });

    this.sessionExpiredSubscription = this.authService.sessionExpiredObservable.subscribe(() => {
      if (!this.allowSessionExpiredModal) {
        this.allowSessionExpiredModal = true;

        this.openSessionExpiredModal.nativeElement.click();
      }
    });

    this.sessionForbiddenSubscription = this.authService.sessionForbiddenObservable.subscribe(() => {
      if (!this.allowSessionForbiddenModal) {
        this.allowSessionForbiddenModal = true;

        this.openSessionForbiddenModal.nativeElement.click();
      }
    });

    this.sessionIncompleteSubscription = this.authService.sessionIncompleteObservable.subscribe((erro: string) => {
      if (!this.allowSessionIncompleteModal) {
        this.allowSessionIncompleteModal = true;
        this.messageError= erro;
        this.openSessionIncompleteModal.nativeElement.click();
      }
    });


      this.authService.initAuth();
  }

  ngOnDestroy() {
    if (this.isDesktopSubscription) {
      this.isDesktopSubscription.unsubscribe();
    }

    if (this.modalIsOpenSubscription) {
      this.modalIsOpenSubscription.unsubscribe();
    }

    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }

    if (this.isLoadingApiAuthSubscription) {
      this.isLoadingApiAuthSubscription.unsubscribe();
    }

    if (this.hasApiAuthErrorSubscription) {
      this.hasApiAuthErrorSubscription.unsubscribe();
    }

    if (this.isLoadingUserAuthSubscription) {
      this.isLoadingUserAuthSubscription.unsubscribe();
    }

    if (this.hasUserAuthErrorSubscription) {
      this.hasUserAuthErrorSubscription.unsubscribe();
    }

    if (this.sessionExpiredSubscription) {
      this.sessionExpiredSubscription.unsubscribe();
    }

    this.sessionIncompleteSubscription?.unsubscribe();
  }

  public refreshPage() {
    location.reload();
  }

  public handleSessionExpiredModalClose() {
    this.authService.logout(null, true);
  }

  public handleSessionIncompleteModalClose(){
    this.authService.logout(null, true);
    this.authService.initLoginCidadao();
  }

  public handleSessionForbiddenModalClose() {
    this.authService.logout(null, true);
  }
}
